module.exports = __webpack_public_path__ + "static/media/group_offers.647e61ca.png";